module.exports = __webpack_public_path__ + "img/plus.e70a14eb.svg";